import React from "react";
import styles from '../ProfilePage.module.css';

const UserDetails = ({ userData }) => {
    return(
        <div className={styles.infoSection}>
        <div className={styles.infoItem}>
                <div className={styles.infoIcon}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="2" y="4" width="20" height="16" rx="2"></rect>
                        <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                    </svg>
                </div>
                <div className={styles.infoContent}>
                    <label>Full Name</label>
                    <span>{userData.fullname}</span>
                </div>
            </div>
            
            <div className={styles.infoItem}>
                <div className={styles.infoIcon}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                </div>
                <div className={styles.infoContent}>
                    <label>Username</label>
                    <span>{userData.username}</span>
                </div>
            </div>

            <div className={styles.infoItem}>
                <div className={styles.infoIcon}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="2" y="4" width="20" height="16" rx="2"></rect>
                        <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                    </svg>
                </div>
                <div className={styles.infoContent}>
                    <label>Email</label>
                    <span>{userData.email}</span>
                </div>
            </div>

            <div className={styles.infoItem}>
                <div className={styles.infoIcon}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="2" y="4" width="20" height="16" rx="2"></rect>
                        <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                    </svg>
                </div>
                <div className={styles.infoContent}>
                    <label>Company Name</label>
                    <span>{userData.companyname}</span>
                </div>
            </div>
        </div>
    );
};

export default UserDetails;